import { MODULE_LINK_TYPE, MT_MODULES } from '../constants';
export const ADMIN = {
  [MODULE_LINK_TYPE.BUILD]: (moduleId: string, seriesId: string) =>
    `/ui/coaching/${MT_MODULES.ONE_TO_ONE_COACHING}/admin/${seriesId}/${moduleId}/build/addactivity`,
  [MODULE_LINK_TYPE.INVITE_TRACK]: (moduleId: string, seriesId: string) =>
    `/ui/coaching/${MT_MODULES.ONE_TO_ONE_COACHING}/admin/${seriesId}/${moduleId}/invite-track/learner/all`,
  [MODULE_LINK_TYPE.ANALYTICS]: (moduleId: string, seriesId: string, moduleName: string) =>
    `modules/${moduleId}/one_to_one_coaching/reviewers?gameType=one_to_one_coaching&inSeries=${seriesId}&name=${moduleName}`,
};

export const LEARNER = {};
